
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      name: ''
    };
  }, // data
    mounted: function() {
        this.hideMenu() // Calls the method before page loads
    },
    methods: {
          hideMenu: function() {
    // Get a handle to the iframe element
    var iframe = document.getElementById('myFrame');
    var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // Check if loading is complete
    if (  iframeDoc.readyState  == 'complete' ) {
        //iframe.contentWindow.alert("Hello");
        iframe.contentWindow.onload = function(){
            alert("I am loaded");
            
        };
        return;
        // The loading is complete, call the function we want executed once the iframe is loaded
    } 
    // If we are here, it is not loaded. Set things up so we check   the status again in 100 milliseconds
    window.setTimeout(this.hideMenu, 100);
},
    }
}; // export default
